export var pageLayoutRootDataAttr = 'data-core-page-layout-root';
export var pageLayoutRootDataAttrName = 'pageCoreLayoutRoot';
//# sourceMappingURL=PageLayout.constants.js.map